import { render, staticRenderFns } from "./QwenImageSeoContent.vue?vue&type=template&id=bcbd8660&scoped=true"
import script from "./QwenImageSeoContent.vue?vue&type=script&lang=js"
export * from "./QwenImageSeoContent.vue?vue&type=script&lang=js"
import style0 from "./QwenImageSeoContent.vue?vue&type=style&index=0&id=bcbd8660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbd8660",
  null
  
)

export default component.exports